import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';

import { config } from '../../../../config';
import { Statistics } from './admin.model';

@Injectable()
export class AdminService {
  constructor(private http: HttpClient) {}

  statistics(date): Observable<Statistics> {
    return this.http
      .post<Statistics>(`${config.apiLocation}/v1/admin/statistics`, date);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/admin/admin.service.ts